/* Éllan — mobile-only image slider on product cards (Bluorng-style dots).
   Initializes Swiper on [data-card-media-swiper] below 750px, destroys above. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var instances = [];

  function initAll() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('[data-card-media-swiper]').forEach(function (el) {
      if (el.swiper) return;
      instances.push(
        new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
        })
      );
    });
  }

  function destroyAll() {
    instances.forEach(function (s) {
      if (s && s.destroy) s.destroy(true, true);
    });
    instances = [];
  }

  function update() {
    if (mq.matches) {
      initAll();
    } else {
      destroyAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', update);
  } else if (mq.addListener) {
    mq.addListener(update);
  }

  document.addEventListener('shopify:section:load', update);

  /* Cards injected later (recommendations, quick view, filtering) */
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled || !mq.matches) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
